import React, { useEffect, useState } from "react";
import UserSidebar from "./UserSidebar";

const UserProfile = () => {
  const [userData, setUserData] = useState({
    name: "",
    surname: "",
    email: "",
    company: "",
    phone: "",
    avatarUrl: "",
    city: "",
    state: "",
    address: "",
    vat: "",
    postal_code: "",
  });
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const fetchUserProfile = async () => {
    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const host = import.meta.env.VITE_HOST;
      const port = import.meta.env.VITE_PORT;
      const token = localStorage.getItem("jwt_token");
      const userIdStr = localStorage.getItem("user_id");

      if (!token || !userIdStr) {
        setError("Token o user ID mancante. Effettua il login.");
        setLoading(false);
        return;
      }

      const userId = parseInt(userIdStr, 10);

      const url = `${host}:${port}/api/v1/users/user_info?_id=${userId}`;

      const res = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.detail || `Errore HTTP ${res.status}`);
      }

      const response = await res.json();
      const data = response?.data?.[0];

      if (!data) throw new Error("Dati utente non trovati.");

      setUserData({
        name: data.name || "",
        surname: data.surname || "",
        email: data.email || "",
        company: data.company || "",
        phone: data.phone || "",
        avatarUrl: data.avatarUrl || "",
        city: data.city || "",
        state: data.state || "",
        address: data.address || "",
        vat: data.vat || "",
        postal_code: data.postal_code || "",
      });
    } catch (err) {
      setError(err.message || "Errore durante il caricamento.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserProfile();
    //window.location.href = "/user-profile";
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    if (!userData.name.trim()) return "Il nome è obbligatorio.";
    if (!userData.surname.trim()) return "Il cognome è obbligatorio.";
    if (!userData.email.trim()) return "L'email è obbligatoria.";
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(userData.email)) return "Email non valida.";
    return null;
  };

  const handleSave = async () => {
    setError("");
    setSuccess("");
    const validationError = validate();
    if (validationError) {
      setError(validationError);
      return;
    }

    setSaving(true);
    try {
      const host = import.meta.env.VITE_HOST;
      const port = import.meta.env.VITE_PORT;
      const token = localStorage.getItem("jwt_token");
      const userIdStr = localStorage.getItem("user_id");

      if (!token || !userIdStr) {
        setError("Token o user ID mancante.");
        setSaving(false);
        return;
      }

      const userId = parseInt(userIdStr, 10);

      const url = `${host}:${port}/api/v1/users/edit_user`;

      const bodyData = {
        id_user: userId,
        name: userData.name,
        surname: userData.surname,
        email: userData.email,
        company: userData.company,
        phone: userData.phone,
        city: userData.city,
        state: userData.state,
        address: userData.address,
        vat: userData.vat,
        postal_code: userData.postal_code ? Number(userData.postal_code) : null,
      };

      const res = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(bodyData),
      });

      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.detail || `Errore HTTP ${res.status}`);
      }

      setSuccess("Profilo aggiornato con successo!");

       // Ricarico la pagina dopo 1 secondo per far vedere il messaggio
        setTimeout(() => {
          window.location.reload();
          // oppure window.location.href = "/user-profile";
        }, 1000);

    } catch (err) {
      setError(err.message || "Errore durante il salvataggio.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      <UserSidebar />
      <main className="flex-1 p-6 max-w-3xl mx-auto">
        {loading && <p className="text-gray-700">Caricamento dati...</p>}
        {error && (
          <div className="mb-4 p-3 bg-red-100 text-red-700 rounded">{error}</div>
        )}
        {success && (
          <div className="mb-4 p-3 bg-green-100 text-green-700 rounded">
            {success}
          </div>
        )}
        {!loading && (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSave();
            }}
            className="bg-white rounded shadow p-6 space-y-2"
          >
            {/* Nome e Cognome */}
            <div className="flex gap-4">
              <div className="flex-1">
                <label
                  htmlFor="name"
                  className="block font-semibold text-gray-900 mb-1"
                >
                  Nome <span className="text-red-500">*</span>
                </label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  value={userData.name}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded px-3 py-2 text-black focus:outline-none focus:ring focus:border-[#94c41c]"
                />
              </div>
              <div className="flex-1">
                <label
                  htmlFor="surname"
                  className="block font-semibold text-gray-900 mb-1"
                >
                  Cognome <span className="text-red-500">*</span>
                </label>
                <input
                  id="surname"
                  name="surname"
                  type="text"
                  value={userData.surname}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded px-3 py-2 text-black focus:outline-none focus:ring focus:border-[#94c41c]"
                />
              </div>
            </div>

            {/* Email */}
            <div>
              <label
                htmlFor="email"
                className="block font-semibold text-gray-900 mb-1"
              >
                Email <span className="text-red-500">*</span>
              </label>
              <input
                id="email"
                name="email"
                type="email"
                value={userData.email}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded px-3 py-2 text-black focus:outline-none focus:ring focus:border-[#94c41c]"
              />
            </div>

            {/* Azienda */}
            <div>
              <label
                htmlFor="company"
                className="block font-semibold text-gray-900 mb-1"
              >
                Azienda
              </label>
              <input
                id="company"
                name="company"
                type="text"
                value={userData.company}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded px-3 py-2 text-black focus:outline-none focus:ring focus:border-[#94c41c]"
              />
            </div>

            {/* Telefono */}
            <div>
              <label
                htmlFor="phone"
                className="block font-semibold text-gray-900 mb-1"
              >
                Telefono
              </label>
              <input
                id="phone"
                name="phone"
                type="tel"
                value={userData.phone}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded px-3 py-2 text-black focus:outline-none focus:ring focus:border-[#94c41c]"
              />
            </div>

            {/* Città e Stato */}
            <div className="flex gap-4">
              <div className="flex-1">
                <label
                  htmlFor="city"
                  className="block font-semibold text-gray-900 mb-1"
                >
                  Città
                </label>
                <input
                  id="city"
                  name="city"
                  type="text"
                  value={userData.city}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded px-3 py-2 text-black focus:outline-none focus:ring focus:border-[#94c41c]"
                />
              </div>
              <div className="flex-1">
                <label
                  htmlFor="state"
                  className="block font-semibold text-gray-900 mb-1"
                >
                  Provincia / Stato
                </label>
                <input
                  id="state"
                  name="state"
                  type="text"
                  value={userData.state}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded px-3 py-2 text-black focus:outline-none focus:ring focus:border-[#94c41c]"
                />
              </div>
            </div>

            {/* Indirizzo e CAP */}
            <div className="flex gap-4">
              <div className="flex-2 min-w-0">
                <label
                  htmlFor="address"
                  className="block font-semibold text-gray-900 mb-1"
                >
                  Indirizzo
                </label>
                <input
                  id="address"
                  name="address"
                  type="text"
                  value={userData.address}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded px-3 py-2 text-black focus:outline-none focus:ring focus:border-[#94c41c]"
                />
              </div>
              <div className="flex-1 min-w-[100px]">
                <label
                  htmlFor="postal_code"
                  className="block font-semibold text-gray-900 mb-1"
                >
                  CAP
                </label>
                <input
                  id="postal_code"
                  name="postal_code"
                  type="number"
                  value={userData.postal_code}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded px-3 py-2 text-black focus:outline-none focus:ring focus:border-[#94c41c]"
                />
              </div>
            </div>

            {/* Partita IVA */}
            <div>
              <label
                htmlFor="vat"
                className="block font-semibold text-gray-900 mb-1"
              >
                Partita IVA
              </label>
              <input
                id="vat"
                name="vat"
                type="text"
                value={userData.vat}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded px-3 py-2 text-black focus:outline-none focus:ring focus:border-[#94c41c]"
              />
            </div>

            <button
              type="submit"
              disabled={saving}
              className={`w-full py-3 text-white rounded ${
                saving ? "bg-gray-400 cursor-not-allowed" : "bg-[#94c41c]"
              } hover:bg-green-700 transition`}
            >
              {saving ? "Salvataggio..." : "Salva"}
            </button>
          </form>
        )}
      </main>
    </div>
  );
};

export default UserProfile;
